export default [

    {
        name: 'tableau1Texture',
        type: 'texture',
        path: './models/tableau1Texture.jpg'

    },

    {
        name: 'tableau1Model',
        type: 'gltfModel',
        path: './models/tableau1.glb'

    },
    {
        name: 'noise',
        type: 'texture',
        path: './textures/noise.png'

    },
    {
        name: 'batiment',
        type: 'gltfModel',
        path: './models/batiment.glb'

    },
    {
        name: 'road',
        type: 'gltfModel',
        path: './models/road.glb'

    },




]

